module.exports = __webpack_public_path__ + "static/mobile-apps-ef05e088e622206da817181ce870bf8f.jpg";